/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  UseMutationOptions,
  UseMutationResult,
  QueryClient,
} from "@tanstack/react-query";
import type {
  PostApiV1ExamQuestionLibraryItemMutationRequest,
  PostApiV1ExamQuestionLibraryItemMutationResponse,
  PostApiV1ExamQuestionLibraryItem400,
  PostApiV1ExamQuestionLibraryItem401,
  PostApiV1ExamQuestionLibraryItem500,
} from "../../types/examQuestionLibraryController/PostApiV1ExamQuestionLibraryItem.ts";
import { mutationOptions, useMutation } from "@tanstack/react-query";
import { postApiV1ExamQuestionLibraryItem } from "../../clients/examQuestionLibraryController/postApiV1ExamQuestionLibraryItem.ts";

export const postApiV1ExamQuestionLibraryItemMutationKey = () =>
  [{ url: "/api/v1/exam/question-library/item" }] as const;

export type PostApiV1ExamQuestionLibraryItemMutationKey = ReturnType<
  typeof postApiV1ExamQuestionLibraryItemMutationKey
>;

export function postApiV1ExamQuestionLibraryItemMutationOptions<
  TContext = unknown,
>(
  config: Partial<
    RequestConfig<PostApiV1ExamQuestionLibraryItemMutationRequest>
  > & { client?: Client } = {},
) {
  const mutationKey = postApiV1ExamQuestionLibraryItemMutationKey();
  return mutationOptions<
    PostApiV1ExamQuestionLibraryItemMutationResponse,
    ResponseErrorConfig<
      | PostApiV1ExamQuestionLibraryItem400
      | PostApiV1ExamQuestionLibraryItem401
      | PostApiV1ExamQuestionLibraryItem500
    >,
    { data: PostApiV1ExamQuestionLibraryItemMutationRequest },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ data }) => {
      return postApiV1ExamQuestionLibraryItem(data, config);
    },
  });
}

/**
 * @description Cria uma nova questão na biblioteca de questões. O tipo do componente determina quais campos são obrigatórios. Para questões de lista (Escolha Simples ou Múltipla Escolha), a lista de opções deve ser fornecida no campo ExamTypeList. **(Requer Authorization para autenticação)**
 * @summary Criar questão na biblioteca (Requer Authorization para autenticação)
 * {@link /api/v1/exam/question-library/item}
 */
export function usePostApiV1ExamQuestionLibraryItem<TContext>(
  options: {
    mutation?: UseMutationOptions<
      PostApiV1ExamQuestionLibraryItemMutationResponse,
      ResponseErrorConfig<
        | PostApiV1ExamQuestionLibraryItem400
        | PostApiV1ExamQuestionLibraryItem401
        | PostApiV1ExamQuestionLibraryItem500
      >,
      { data: PostApiV1ExamQuestionLibraryItemMutationRequest },
      TContext
    > & { client?: QueryClient };
    client?: Partial<
      RequestConfig<PostApiV1ExamQuestionLibraryItemMutationRequest>
    > & { client?: Client };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ??
    postApiV1ExamQuestionLibraryItemMutationKey();

  const baseOptions = postApiV1ExamQuestionLibraryItemMutationOptions(
    config,
  ) as UseMutationOptions<
    PostApiV1ExamQuestionLibraryItemMutationResponse,
    ResponseErrorConfig<
      | PostApiV1ExamQuestionLibraryItem400
      | PostApiV1ExamQuestionLibraryItem401
      | PostApiV1ExamQuestionLibraryItem500
    >,
    { data: PostApiV1ExamQuestionLibraryItemMutationRequest },
    TContext
  >;

  return useMutation<
    PostApiV1ExamQuestionLibraryItemMutationResponse,
    ResponseErrorConfig<
      | PostApiV1ExamQuestionLibraryItem400
      | PostApiV1ExamQuestionLibraryItem401
      | PostApiV1ExamQuestionLibraryItem500
    >,
    { data: PostApiV1ExamQuestionLibraryItemMutationRequest },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    PostApiV1ExamQuestionLibraryItemMutationResponse,
    ResponseErrorConfig<
      | PostApiV1ExamQuestionLibraryItem400
      | PostApiV1ExamQuestionLibraryItem401
      | PostApiV1ExamQuestionLibraryItem500
    >,
    { data: PostApiV1ExamQuestionLibraryItemMutationRequest },
    TContext
  >;
}
